var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Tooltip } from '../';
var COLORS;
(function (COLORS) {
    COLORS["PICKER_RED"] = "f35444";
    COLORS["PICKER_ORANGE"] = "f89940";
    COLORS["PICKER_GREEN"] = "57b11f";
    COLORS["PICKER_BLUE"] = "2980b9";
    COLORS["PICKER_PINK"] = "f87cac";
    COLORS["PICKER_YELLOW"] = "fcdd2a";
    COLORS["PICKER_LIME"] = "a7e038";
    COLORS["PICKER_CYAN"] = "4ac8e4";
    COLORS["PICKER_PURPLE"] = "8e44ad";
    COLORS["PICKER_BROWN"] = "cd9e60";
    COLORS["PICKER_GRAY"] = "7f8c8d";
    COLORS["PICKER_SILVER"] = "ecf0f1";
})(COLORS || (COLORS = {}));
var panelWidth = 40;
var margin = 8;
var OverlayWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  padding: ", "px 0 0 ", "px;\n  width: ", "px;\n\n  > div {\n    margin: 0 ", "px ", "px 0;\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  padding: ", "px 0 0 ", "px;\n  width: ",
    "px;\n\n  > div {\n    margin: 0 ", "px ", "px 0;\n  }\n"])), margin, margin, function (_a) {
    var _b = _a.columnNumber, columnNumber = _b === void 0 ? 4 : _b;
    return panelWidth * columnNumber + margin + margin * columnNumber;
}, margin, margin);
var ColorPanel = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: ", ";\n  border-radius: 4px;\n  height: ", "px;\n  width: ", "px;\n  cursor: pointer;\n"], ["\n  background: ", ";\n  border-radius: 4px;\n  height: ", "px;\n  width: ", "px;\n  cursor: pointer;\n"])), function (props) { return "#" + props.color; }, panelWidth, panelWidth);
var Overlay = function (props) {
    var decoder;
    if (props.decoder) {
        decoder = props.decoder;
    }
    else {
        decoder = function (color) { return color; };
    }
    return (React.createElement(OverlayWrapper, { columnNumber: props.columnNumber }, Object.keys(COLORS).map(function (key, i) { return (React.createElement(ColorPanel, { key: i, color: COLORS[key], onClick: function () {
            props.onChangeColor(decoder(COLORS[key]));
            props.onClick();
        } })); })));
};
var ColorPicker = (function (_super) {
    __extends(ColorPicker, _super);
    function ColorPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            visible: false,
        };
        _this.togglePicker = function (bool) {
            _this.setState({
                visible: bool,
            });
        };
        return _this;
    }
    ColorPicker.getDerivedStateFromProps = function (nextProps) {
        if ('visible' in nextProps) {
            return {
                visible: nextProps.visible,
            };
        }
        return null;
    };
    ColorPicker.prototype.render = function () {
        var _this = this;
        return (React.createElement(Tooltip, __assign({}, this.props, { visible: this.state.visible, onVisibleChange: function (bool) { return _this.togglePicker(bool); }, getTooltipContainer: this.props.getTooltipContainer || (function () { return _this.container; }), overlay: React.createElement(Overlay, __assign({}, this.props, { onClick: function () { return _this.togglePicker(false); } })) }),
            React.createElement("div", { ref: function (ref) {
                    _this.container = ref;
                }, style: { display: 'inline-block' } },
                React.createElement(ColorLabel, { color: this.props.currentColor }))));
    };
    ColorPicker.defaultProps = {
        placement: 'rightTop',
        columnNumber: 4,
    };
    return ColorPicker;
}(React.Component));
var ColorLabel = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: ", ";\n  display: inline-block;\n  height: 28px;\n  width: 28px;\n  cursor: pointer;\n  border-radius: 4px;\n"], ["\n  background-color: ", ";\n  display: inline-block;\n  height: 28px;\n  width: 28px;\n  cursor: pointer;\n  border-radius: 4px;\n"])), function (_a) {
    var color = _a.color;
    return "#" + color;
});
export default ColorPicker;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=colorpicker.js.map